/* eslint-disable @typescript-eslint/no-explicit-any */
import { batch } from 'react-redux';

// Call ajax actions in batch, returns a batch promise that waits until all the calls have been completed.
// On the server these calls are run in the same transaction.
export function callAjaxInBatch(callbackForActions: any): BatchCallAction {
  return (dispatch: Dispatch) => {
    return batch(() => {
      dispatch(beginBatch());
      callbackForActions();
      return dispatch(endBatch());
    });
  };
}

// Update redux store in batch, react will wait for all the reducer updates to complete
// before calling the render loop improving rendering performance.
export function runActionsInBatch(callbackForActions: any) {
  return (dispatch: Dispatch) => {
    batch(() => {
      callbackForActions();
    });
  };
}

function beginBatch(): ApiAction {
  return {
    TockApi: {
      beginBatch: 'beginBatch',
    },
  };
}

function endBatch(): ApiAction {
  return {
    TockApi: {
      endBatch: 'endBatch',
    },
  };
}
